import DataApi from './DataApi';

class StageMasterApi extends DataApi {
  constructor() {
    super('stage-master');
  }

  fetchStages() {
    return this.get('');
  }

  createStage(payload) {
    return this.post('', payload);
  }

  updateStage(id, payload) {
    return this.put(`/${id}`, payload);
  }

  deleteStage(id) {
    return this.delete(`/${id}`);
  }
}

export default StageMasterApi;
